import { useState, useEffect, useRef } from 'react';
import STYLES from './Window.module.scss';

import { projectImageData } from '../../../../images/imageData';

const Window = ({ project, onClose }) => {
  const { name, description, imageName } = project;
  const [image, setImage] = useState(null);
  const windowRef = useRef(null);

  useEffect(() => {
    if (!imageName) {
      import('../../../../images/project1.png').then((image) =>
        setImage(image.default)
      );
    } else {
      setImage(projectImageData[imageName] || null);
    }
  }, [project]);

  if (!image) return null;

  return (
    <div className={STYLES.Window} ref={windowRef}>
      <div className={STYLES.Window__header}>
        <span className={STYLES.Window__title}>📂 {name}</span>
        <button className={STYLES.Window__closeButton} onClick={onClose}>
          X
        </button>
      </div>
      <div className={STYLES.WindowContent}>
        <img src={image} className={STYLES.WindowContent__image} />
        <div className={STYLES.WindowContent__description}>
          <p>{description}</p>
          <div className={STYLES.WindowContent__controls}>
            {project?.url && (
              <a href={project.url} target="_blank" rel="noopener noreferrer">
                Open
              </a>
            )}
            {project?.github && (
              <a
                href={project.github}
                target="_blank"
                rel="noopener noreferrer"
              >
                Github
              </a>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Window;
